import { render, staticRenderFns } from "./OdontogramCreateDialog.vue?vue&type=template&id=95338376&scoped=true"
import script from "./OdontogramCreateDialog.vue?vue&type=script&lang=js"
export * from "./OdontogramCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./OdontogramCreateDialog.vue?vue&type=style&index=0&id=95338376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95338376",
  null
  
)

export default component.exports